import { Link } from 'react-router-dom';
import { Twitter, Linkedin, Github, Mail } from 'lucide-react';

const LINKS = {
  Product: [
    { label: 'Services',   to: '/services'   },
    // { label: 'Pricing',    to: '/pricing'     },
    { label: 'Samples',    to: '/samples'     },
    { label: 'Free Leads', to: '/free-leads'  },
  ],
  Company: [
    { label: 'Contact Us',       to: '/contact' },
    { label: 'Privacy Policy',   to: '/privacy' },
    { label: 'Terms of Service', to: '/terms'   },
  ],
};

export default function Footer() {
  return (
      <footer className="border-t border-slate-200 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12 sm:py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10">

          {/* ── Brand ── */}
          <div className="sm:col-span-2">
            {/* ── Logo ── */}
          <Link to="/" className="flex items-center gap-1.5 mb-1 group shrink-0">
            <img
              src="/logo-light-new.jpg"
              alt="LeadOnLeads Logo"
              className="h-7 sm:h-8 w-auto object-contain transition-transform group-hover:scale-105"
              onError={(e) => { e.target.style.display = 'none'; }}
            />
            <span
              className="font-bold text-lg sm:text-xl text-slate-900 tracking-tight"
              style={{ fontFamily: 'Sora, sans-serif', letterSpacing: '-0.02em' }}
            >
              LeadOn<span className="text-brand-600">Leads</span>
            </span>
          </Link>

            <p className="text-slate-600 text-sm leading-relaxed max-w-xs mb-6">
              The most powerful lead generation platform for modern businesses.
              Get qualified leads fast, verified, and ready to convert.
            </p>

            {/* Social icons */}
            <div className="flex items-center gap-2.5">
              {[
                { Icon: Twitter,  href: '#',                             label: 'Twitter'  },
                { Icon: Linkedin, href: 'https://www.linkedin.com/company/leadonleads',                             label: 'LinkedIn' },
                { Icon: Github,   href: '#',                             label: 'GitHub'   },
                { Icon: Mail,     href: 'mailto:contact@leadonleads.com', label: 'Email'   },
              ].map(({ Icon, href, label }) => (
                <a
                  key={label}
                  href={href}
                  aria-label={label}
                  className="w-8 h-8 rounded-lg border border-slate-200 flex items-center justify-center
                    text-slate-500 hover:text-brand-600 hover:border-brand-300 hover:bg-brand-50 transition-all duration-200"
                >
                  <Icon size={14} />
                </a>
              ))}
            </div>
          </div>

          {/* ── Link columns ── */}
          {Object.entries(LINKS).map(([title, links]) => (
            <div key={title}>
              <h4 className="text-[11px] font-semibold text-slate-500 uppercase tracking-widest mb-4">
                {title}
              </h4>
              <ul className="space-y-2.5">
                {links.map((link) => (
                  <li key={link.to}>
                    <Link
                      to={link.to}
                      className="text-slate-600 hover:text-brand-600 text-sm transition-colors duration-150"
                    >
                      {link.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        {/* ── Bottom bar ── */}
        <div className="border-t border-slate-200 mt-12 pt-6 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-slate-500 text-xs">
            © {new Date().getFullYear()} LeadOnLeads. All rights reserved.
          </p>
          <p className="text-slate-400 text-xs">
            Built for high-growth sales teams
          </p>
        </div>
      </div>
    </footer>
  );
}
